import { theme } from "nectar-ui";
import { DASHBOARD_CHART_TYPES } from "../../../utils/constants/dashboard/dashboardModuleConstants";
import { apexChartInvertedSeriesClickHandler } from "../../../utils/helpers/dashboardHelpers";
import activityTypes from "../../../utils/constants/activities/activitiesTypes";

import { getCalendarActivityColors } from "../helpers";
import { ApexOptions } from "apexcharts";

export const getChartHeightByPowers = (
  hasMediumRangePowers: boolean,
  hasMaximumRangePowers: boolean,
  isMobileScreen: boolean
) => {
  let height = 0;

  if (hasMaximumRangePowers) {
    height = 580;
  } else if (hasMediumRangePowers) {
    height = 360;
  } else {
    height = 220;
  }

  if (isMobileScreen) height += 135;

  return height;
};

export const getChartOptions = (
  months: string[],
  calendarActivityTypes: (keyof typeof activityTypes)[]
): ApexOptions => {
  return {
    chart: {
      id: DASHBOARD_CHART_TYPES.DONE_ACTIVITIES_BY_MONTH.chart,
      type: "bar",
      stacked: true,
      fontFamily: theme.nectar.fontStack.default,
      toolbar: {
        show: false,
      },
      events: {
        legendClick: apexChartInvertedSeriesClickHandler,
      },
    },
    colors: getCalendarActivityColors(calendarActivityTypes),
    states: {
      active: {
        filter: {
          type: "none",
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        borderRadiusWhenStacked: "last",
        borderRadiusApplication: "end",
        columnWidth: "80%",
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: "14px",
              color: theme.nectar.colors.gray900,
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      width: 2,
      colors: ["#fff"],
    },
    xaxis: {
      categories: months ?? "",
      labels: {
        rotateAlways: false,
        trim: true,
        style: {
          fontSize: "14px",
          fontWeight: 300,
          colors: theme.nectar.colors.gray500,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "14px",
          fontWeight: 500,
          colors: theme.nectar.colors.gray500,
        },
      },
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    dataLabels: {
      style: {
        colors: [theme.nectar.colors.gray900],
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "14px",
      onItemClick: {
        toggleDataSeries: false,
      },
    },
  };
};
